import { CountriesResponse, RegionsResponse } from '@/types/misc'
import { defineStore } from 'pinia'

interface States {
  countries: Ref<CountriesResponse | null>
  regions: Ref<RegionsResponse | null>
}

export const useMiscStore = defineStore('misc', () => {
  const states: States = {
    countries: ref(null),
    regions: ref(null),
  }

  const resetStore = () => {
    states.countries.value = null
    states.regions.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
